import { render, staticRenderFns } from "./CT-SL-Disclosure.vue?vue&type=template&id=882b5948&scoped=true&"
import script from "./CT-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./CT-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./CT-SL-Disclosure.vue?vue&type=style&index=0&id=882b5948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882b5948",
  null
  
)

export default component.exports